import ReviewsQueryBase from "@apps/reviews/queries/ReviewsQueryBase";
import { Observable, map } from "rxjs";

import { ReviewItemSdkDto, ReviewsPaginationMetaSdkDto } from "../types";
import { mapReviewItemToSdkDto } from "../utils/mapReviewItemToSdkDto";
import { mapReviewsPaginationMetaToSdkDto } from "../utils/mapReviewsPaginationMetaToSdkDto";

export class ReviewsStateKitQueryWrapper {
    constructor(private readonly _reviewsQuery: ReviewsQueryBase) {}

    selectAll(): Observable<ReviewItemSdkDto[]> {
        return this._reviewsQuery
            .selectAll()
            .pipe(map((reviews) => reviews.map(mapReviewItemToSdkDto)));
    }

    selectPaginationMeta(): Observable<ReviewsPaginationMetaSdkDto> {
        return this._reviewsQuery.paginationMeta$.pipe(
            map(mapReviewsPaginationMetaToSdkDto)
        );
    }

    selectEntity(uid: string): Observable<ReviewItemSdkDto | undefined> {
        return this._reviewsQuery.selectEntity(uid).pipe(
            map((review) => {
                if (!review) return undefined;
                return mapReviewItemToSdkDto(review);
            })
        );
    }

    selectFirst(): Observable<ReviewItemSdkDto | undefined> {
        return this._reviewsQuery.selectFirst().pipe(
            map((review) => {
                if (!review) return undefined;
                return mapReviewItemToSdkDto(review);
            })
        );
    }
}
